// extracted by mini-css-extract-plugin
export default {"zoomModal":"V4-z"};